import React from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { logoutAdminSession } from "../utils/api";
import useStore from "../utils/store";

const Logout = () => {
  const setUser = useStore((state) => state.setUser);
  const navigate = useNavigate();

  React.useEffect(() => {
    const logout = async () => {
      const current = useStore.getState().user;
      if (current?.type === "Admin" && current?.token) {
        await logoutAdminSession(current.token);
      }
      localStorage.removeItem("prabhu_admin_last_activity");
      setUser(null);
      navigate("/login");
    };
    logout();
  }, [navigate, setUser]);

  return <Loading>Logout</Loading>;
};

export default Logout;
